import request from '@/utils/request';
export function classificationList(data) {
  return request.post('admin/insurance-classification/list', data);
}
export function addClassification(data) {
  return request.post('admin/insurance-classification/store', data);
}
export function editClassification(data) {
  return request.post('admin/insurance-classification/edit', data);
}
export function isEditClassification(data) {
  return request.post('admin/insurance-classification/isEdit', data);
}
export function classificationStatus(data) {
  return request.post('admin/insurance-classification/status', data);
}
export function delClassification(data) {
  return request.post('admin/insurance-classification/delete', data);
}
export function labelList(data) {
  return request.post('admin/insurance-label/list', data);
}
export function addLabel(data) {
  return request.post('admin/insurance-label/store', data);
}
export function editLabel(data) {
  return request.post('admin/insurance-label/edit', data);
}
export function isEditLabel(data) {
  return request.post('admin/insurance-label/isEdit', data);
}
export function labelStatus(data) {
  return request.post('admin/insurance-label/status', data);
}
export function delLabel(data) {
  return request.post('admin/insurance-label/delete', data);
}